export const GET_STREET = "config/GET_STREET"
export const GET_STREET_SUCCESS = "config/GET_STREET_SUCCESS"

export const GET_POST_OFFICE = "config/GET_POST_OFFICE"
export const GET_POST_OFFICE_SUCCESS = "config/GET_POST_OFFICE_SUCCESS"

export const GET_VILLAGE = "config/GET_VILLAGE"
export const GET_VILLAGE_SUCCESS = "config/GET_VILLAGE_SUCCESS"

export const GET_AREA = "config/GET_AREA"
export const GET_AREA_SUCCESS = "config/GET_AREA_SUCCESS"

export const GET_VALVE = "config/GET_VALVE"
export const GET_VALVE_SUCCESS = "config/GET_AREA_SUCCESS"

export const GET_GADIVISION = "config/GET_GADIVISION"
export const GET_GADIVISION_SUCCESS = "config/GET_GADIVISION_SUCCESS"

export const GET_BILL_SECTOR = "config/GET_BILL_SECTOR"
export const GET_BILL_SECTOR_SUCCESS = "config/GET_BILL_SECTOR_SUCCESS"

export const GET_CATEGORY = "config/GET_CATEGORY"
export const GET_CATEGORY_SUCCESS = "config/GET_CATEGORY_SUCCESS"
